import { MutationResult, ShortlistInput } from 'sr-types/lib/shortlist/v1/graphql';
import { useMutationWithContext } from '../../common/hooks/useMutationWithContext';
import { failedToastMessage, successToastMessage } from '../../common/utils/commonUtils';
import { client, saveQuery } from '../shortlist';

export const useSaveShortlist = () => {
    const [saveShortlistMutation, { loading: shortlistSaving }] = useMutationWithContext(saveQuery, client);

    const saveShortlist = ({
        input,
        showMessages = true
    }: {
        input: ShortlistInput;
        showMessages?: boolean;
    }): Promise<MutationResult> => {
        return new Promise((resolve, reject) => {
            return saveShortlistMutation({
                variables: {
                    input
                }
            })
                .then((saveShorlistResponse) => {
                    if (saveShorlistResponse.data.saveShortlist.errors) {
                        showMessages && failedToastMessage('shortlist.save.error');
                        reject(saveShorlistResponse);
                    } else {
                        showMessages && successToastMessage('shortlist.save.success');
                        resolve(saveShorlistResponse.data.saveShortlist);
                    }
                })
                .catch((err) => {
                    showMessages && failedToastMessage('shortlist.save.error');
                    reject(err);
                });
        });
    };

    return { saveShortlist, shortlistSaving };
};
